import { formatSmrName } from "component/mapping/iteration/metadatas/SMRMetadatasParams"
import { IterationType } from "constant/iterationType"
import { IterationListItem } from "type/mapping/iteration"
import { RU_DATE_FORMAT } from "util/formatting/date"

export type IterationSummary = {
  // "УПД № 575 от 04.09.2024" или название сметы
  title: string
  // Объект строительства
  object?: string
  // Поставщик, договор — подписью под объектом
  details: string[]
}

const formatShortDate = (date?: string | null) =>
  date ? new Date(date).toLocaleDateString(RU_DATE_FORMAT) : undefined

// Что показать о проверке в истории вместо одного ID: документ, объект, поставщик
export const getIterationSummary = (item: IterationListItem): IterationSummary => {
  const details: string[] = []
  let title = "Без названия"

  if (item.type === IterationType.SMR) {
    title = formatSmrName(item.smr_name || undefined) || "Смета"
  } else if (item.type === IterationType.UTD) {
    const idnDate = formatShortDate(item.idn_date)
    title = item.idn_number
      ? `УПД № ${item.idn_number}${idnDate ? ` от ${idnDate}` : ""}`
      : "УПД"
    if (item.supplier_inn) details.push(`ИНН поставщика ${item.supplier_inn}`)
    if (item.contract_name) details.push(item.contract_name)
  }

  return { title, object: item.building_name || undefined, details }
}
